import { getTextDirection } from '@wix/ricos';

export const isTextDirectionRTL = (text) => getTextDirection(text) === 'rtl';
